// The picker tiers and the "other models in your tier" rule, shared by the image and video model
// data modules so the two pages group related models the same way.

export type ModelTier = 'Quick' | 'Everyday' | 'Pro' | 'Best'

export const TIER_ORDER: ModelTier[] = ['Quick', 'Everyday', 'Pro', 'Best']

interface TieredModel {
  slug: string
  qualities: { tier: ModelTier }[]
}

/** Other models sharing a tier with this one, ordered by tier then list order; each appears under its first tier only. */
export function relatedByTier<M extends TieredModel>(model: M, all: M[]): { tier: ModelTier; models: M[] }[] {
  const placed = new Set<string>()
  return TIER_ORDER.filter((t) => model.qualities.some((q) => q.tier === t))
    .map((tier) => {
      const models = all.filter((m) => m.slug !== model.slug && !placed.has(m.slug) && m.qualities.some((q) => q.tier === tier))
      for (const m of models) placed.add(m.slug)
      return { tier, models }
    })
    .filter((g) => g.models.length > 0)
}
